// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datepicker input{
    padding: .375rem .75rem !important;
    border: 1px solid #ced4da !important;
    width: 100% !important;
    border-radius: 0.25em !important;
}`, "",{"version":3,"sources":["webpack://./src/containers/company/Company.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,sBAAsB;IACtB,gCAAgC;AACpC","sourcesContent":[".datepicker input{\n    padding: .375rem .75rem !important;\n    border: 1px solid #ced4da !important;\n    width: 100% !important;\n    border-radius: 0.25em !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
